import Confirm from "./ConfirmContainer";

export default Confirm;
